export class WorkOrderUpdatePriorityModel {
    public id: number;
    public priority: number;
}
